import { render, staticRenderFns } from "./deptDocumentListDetail.vue?vue&type=template&id=449ddc02&"
import script from "./deptDocumentListDetail.vue?vue&type=script&lang=js&"
export * from "./deptDocumentListDetail.vue?vue&type=script&lang=js&"
import style0 from "./deptDocumentListDetail.vue?vue&type=style&index=0&id=449ddc02&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports